<template>
  <div class="card-content-container">
    <v-img
      height="174px"
      :lazy-src="imagePlaceholder"
      :src="imageUrl"
    />
    <div class="section section-header section-space-bottom--half">
      <span
        class="pointer-on-hover text-small source-url text-ellipsis"
        @click.exact.stop="onRedirectionToSourceDocument"
        @click.middle.stop="onRedirectionToSourceDocument"
      >
        {{ sourceUrl }}
      </span>
      <span v-if="documentDetails.datePublished" class="publish-date text-small">
        {{ $t('components.cards.horizontal.publishedDate', { datePublished }) }}
      </span>
    </div>
    <div
      class="analysis-link-container"
    >
      <v-tooltip
        bottom
      >
        <template v-slot:activator="{ on, attrs }">
          <div
            class="section section-title section-space-bottom pointer-on-hover text-big text-ellipsis--2"
            @click.middle="onRedirectionToAnalysis"
            @click.exact="onRedirectionToAnalysis"
            v-bind="attrs"
            v-on="on"
          >
            {{ documentDetails.title }}
          </div>
        </template>
        <span>
          {{ documentDetails.title }}
        </span>
      </v-tooltip>

      <!-- <div class="text-medium section section-excerpt section-space-bottom text-ellipsis--4">
        {{ documentDetails.excerpt }}
      </div> -->
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import { getDownloadUrlByPath } from '@/shared/firebase/storageFunctions';

const IMAGE_PLACEHOLDER = require('@/shared/assets/images/placeholder.png');

export default {
  name: 'CardContentLargeSize',
  props: {
    documentDetails: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      imagePlaceholder: IMAGE_PLACEHOLDER,
      imageUrl: undefined,
    };
  },
  created() {
    this.updateImageUrl();
  },
  watch: {
    documentDetails() {
      this.updateImageUrl();
    },
  },
  computed: {
    sourceUrl() {
      let foundSourceUrl;
      try {
        foundSourceUrl = (new URL(this.documentDetails.url)).hostname;
      } catch {
        foundSourceUrl = this.documentDetails.url;
      }

      return foundSourceUrl;
    },
    datePublished() {
      const { datePublished } = this.documentDetails;
      const format = 'LLL';
      if (typeof datePublished === 'string') {
        return moment.utc(this.documentDetails.datePublished).format(format);
      }

      return moment.utc(datePublished.seconds * 1000).format(format);
    },
    tags() {
      if (this.documentDetails.tags) {
        return this.documentDetails.tags;
      }
      return [];
    },
  },
  methods: {
    async updateImageUrl() {
      let url = this.documentDetails.leadImageUrl;

      if (!url) {
        this.imageUrl = undefined;
        return;
      }

      if (url.includes('/img/image_not_found.316e59c7.svg')) {
        this.imageUrl = undefined;
        return;
      }


      if (this.documentDetails.isUpload) {
        url = await getDownloadUrlByPath(url);
      }

      this.imageUrl = url;
    },
    onRedirectionToAnalysis() {
      this.$emit('onRedirectionToAnalysis');
    },
    onRedirectionToSourceDocument() {
      this.$emit('onRedirectionToSourceDocument');
    },
  },
};
</script>
<style scoped>
.card-content-container {
  height: 280px;
  text-align: left;
}
.publish-date {
  white-space: nowrap;
}
.source-url {
  padding-right: 8px;
}
.source-url:hover {
  text-decoration: underline;
}
.pointer-on-hover:hover {
  cursor: pointer;
}
.analysis-link-container {
  text-decoration: none;
  color: black;
}
.text-ellipsis {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.text-ellipsis--2{
  text-overflow:ellipsis;
  overflow:hidden;
  display: -webkit-box !important;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
}
.text-ellipsis--4{
  text-overflow:ellipsis;
  overflow:hidden;
  display: -webkit-box !important;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  white-space: normal;
}
.section {
  margin-left: 32px;
  margin-right: 32px;
}
.section-space-bottom {
  margin-bottom: 16px;
}
.section-space-bottom--half {
  margin-bottom: 8px;
  margin-top: 8px;
}
.section-header {
  display: flex;
  justify-content: space-between;
}
.section-title {
  max-height: 44px;
}
.section-excerpt {
  max-height: 80px;
}
.text-small {
  font-size: 10px;
  font-weight: 300;
  color: rgb(60, 60, 60);
}
.text-medium {
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  color: rgb(60, 60, 60);
}
.text-big {
  font-size: 16px;
  line-height: 22px;
  font-weight: 600;
  color: rgb(60, 60, 60);
}

::v-deep .v-image__image--preload {
  filter: none;
}
</style>
